import React from 'react';
import config from 'react-global-configuration';
import { Spin, Icon } from 'antd';
import store from '../../redux/store';
import * as currentUserActionConst from '../../redux/currentUser/actions';

const LogOut = (props) => {
    let appConfig = config.get("appConfig");
    console.log(appConfig);

    localStorage.removeItem('SCGChem.PMM.WasteMgnt.WebUI.token');
    store.dispatch({ type: currentUserActionConst.SET_USER, payload: null });

    window.location = appConfig.ApiServer_LogOut_Endpoint;

    return (<div style={{ position: 'fixed', top: '50%', left: '50%', marginLeft: '-16px', marginTop: '-19px' }}><Spin size="large" /></div>);
}

export default LogOut;
